import { ColorEnum } from '@/constants/color'
import { Order } from '@/features/orders/types/app'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleSheet } from 'react-native'

interface DeliveryTypeInfoProps {
    customerName?: Order['customerName']
    deliveryAddress?: Order['deliveryAddress']
}

const DeliveryTypeInfo: FC<DeliveryTypeInfoProps> = ({ customerName, deliveryAddress }) => {
    if (deliveryAddress) {
        return (
            <Typography.Description
                numberOfLines={1}
                size="small"
                font="medium"
                style={styles.text}
            >
                {deliveryAddress.street} {deliveryAddress.city}
            </Typography.Description>
        )
    }

    return (
        <Typography.Description numberOfLines={1} size="small" font="medium" style={styles.text}>
            {customerName}
        </Typography.Description>
    )
}

const styles = StyleSheet.create({
    text: {
        color: ColorEnum.GRAY_600,
    },
})

export default DeliveryTypeInfo
